var _g, _path, _path2, _g2, _g3, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProposal = function SvgProposal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 480 353"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#proposal_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184.645,
    height: 184.645,
    fill: "#3B7CC9",
    rx: 48.591,
    transform: "matrix(-1 0 0 1 328.156 72.073)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M268.337 115.51h-40.17v27.255a3.266 3.266 0 0 1-3.266 3.266h-27.255v61.628a4.667 4.667 0 0 0 4.667 4.666h66.024a4.666 4.666 0 0 0 4.666-4.666v-87.482a4.667 4.667 0 0 0-4.666-4.667m-18.392 77.483H223.35a3.266 3.266 0 0 1 0-6.532h26.595a3.267 3.267 0 1 1 0 6.532m0-15.366H223.35a3.266 3.266 0 0 1 0-6.532h26.595a3.267 3.267 0 1 1 0 6.532m0-15.365H223.35a3.266 3.266 0 0 1 0-6.533h26.595a3.267 3.267 0 0 1 0 6.533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M221.595 115.51a4.67 4.67 0 0 0-3.299 1.367l-19.283 19.282a4.67 4.67 0 0 0-1.367 3.299v.04h23.989V115.51z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#proposal_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.027,
    height: 68.027,
    fill: "#FCB701",
    rx: 17.493,
    transform: "matrix(-1 0 0 1 373.094 53)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#proposal_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.027,
    height: 68.027,
    fill: "#51C394",
    rx: 17.493,
    transform: "matrix(-1 0 0 1 170.027 201.095)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M145.992 216.644h-19.958c-3.613 0-6.542 2.988-6.542 6.686v30.597c0 1.298 1.457 2.057 2.485 1.27l6.238-4.782h17.777c3.613 0 6.542-2.988 6.542-6.687V223.33c0-3.693-2.924-6.686-6.542-6.686m-9.979 26.121c-.857 0-1.553-.71-1.553-1.587 0-.875.696-1.587 1.553-1.587s1.553.712 1.553 1.587c0 .877-.696 1.587-1.553 1.587m1.553-7.018v.332c0 .877-.696 1.587-1.553 1.587s-1.553-.71-1.553-1.587v-1.7c0-.876.696-1.587 1.553-1.587 1.437 0 2.605-1.194 2.605-2.662s-1.168-2.663-2.605-2.663c-1.444 0-2.605 1.194-2.605 2.661 0 .876-.695 1.588-1.553 1.588-.857 0-1.552-.71-1.552-1.586v-.002c0-3.228 2.556-5.835 5.708-5.835 3.151 0 5.713 2.618 5.713 5.837 0 2.668-1.761 4.924-4.158 5.617M337.37 88.917a6.784 6.784 0 0 1-9.583 0 3.593 3.593 0 0 1 0-5.074l6.994-6.993q.276-.276.569-.527h-15.48c-.661 0-1.196.536-1.196 1.196v14.543c0 .66.535 1.196 1.196 1.196h6.099l9.449 9.449a5.19 5.19 0 0 0 5.636 1.127l-4.509-4.51a1.196 1.196 0 0 1 1.691-1.69l4.792 4.791 2.254-2.255-4.791-4.79a1.196 1.196 0 0 1 1.691-1.692l4.792 4.791 2.254-2.254-9.583-9.583z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M358.295 76.323h-16.467a7.52 7.52 0 0 0-5.355 2.218l-6.994 6.993a1.196 1.196 0 0 0 0 1.692 4.385 4.385 0 0 0 6.201 0l3.224-3.224c.387-.387.99-.468 1.456-.182 1.44.883 3.457.905 4.641-.279a1.196 1.196 0 0 1 1.691 1.692c-.928.928-2.167 1.464-3.483 1.59l7.711 7.71 1.275-1.275h6.1c.66 0 1.196-.535 1.196-1.195V77.519c0-.66-.536-1.196-1.196-1.196"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F3FF",
    d: "M134.325 79.246a10.15 10.15 0 0 1-12.417 7.204c-5.419-1.44-8.645-6.999-7.206-12.418 1.44-5.42 7.001-8.645 12.42-7.205s8.643 7 7.203 12.419M375.429 237.225c-1.44 5.42-6.998 8.644-12.417 7.204s-8.646-6.998-7.206-12.418 7-8.645 12.42-7.205c5.419 1.44 8.643 7 7.203 12.419"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "proposal_svg__a",
    width: 320.699,
    height: 320.699,
    x: 79.372,
    y: 19.595,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.887,
    dy: 15.549
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.014
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_12549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_561_12549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "proposal_svg__b",
    width: 204.081,
    height: 204.081,
    x: 240.927,
    y: 0.522,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.887,
    dy: 15.549
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.014
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_12549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_561_12549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "proposal_svg__c",
    width: 204.081,
    height: 204.081,
    x: 37.86,
    y: 148.617,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.887,
    dy: 15.549
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.014
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_12549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_561_12549",
    result: "shape"
  })))));
};
export default SvgProposal;